import React, { FC } from "react";

import { IOrganizationContact } from "../../../../../../types/types";
import { ClientTeamCard } from "../../../../../clientTeam/ClientTeamCard";
import { OrganizationEmailsWidget } from "./widgets/organization-emails/OrganizationEmailsWidget";
import { OrganizationFilesWidget } from "./widgets/organization-files/OrganizationFilesWidget";
import { OrganizationInfoView } from "./widgets/organization-info/OrganizationInfoView";
import { OrganizationInvoicesWidget } from "./widgets/organization-invoices/OrganizsationInvoicesWidget";
import { OrganizationLinkedProfilesWidget } from "./widgets/organization-linked-profiles/OrganizationLinkedProfilesWidget";
import { OrganizationNotesWidget } from "./widgets/organization-notes/OrganizationNotesWidget";
import { OrganizationTagsWidget } from "./widgets/organization-tags/OrganizationTagsWidget";
import { OrganizationWorksWidget } from "./widgets/organization-work/OrganizationWorksWidgets";

type Props = {
  organization: IOrganizationContact;
};

/**
 * Organization's profile. Roadmap 1880 (owner 2026-10-22): the Client portal
 * has its own client tab, and Tags is a widget like the others, so the two wide
 * columns hold six even widgets: Work · Notes / Files · Emails / Invoices ·
 * Tags (each 386 px high).
 */
export const OrganizationProfile: FC<Props> = ({ organization }) => {
  return (
    <div
      className={
        "grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,3fr)] gap-6 font-Manrope max-md:grid-cols-1"
      }>
      <div className={"flex h-fit min-w-0 flex-col gap-6"}>
        <OrganizationInfoView />
        <ClientTeamCard customerId={organization?.customerId} />
        <OrganizationLinkedProfilesWidget />
      </div>
      <div className={"flex h-fit min-w-0 flex-col gap-6"}>
        <OrganizationWorksWidget organization={organization} />
        <OrganizationFilesWidget organization={organization} />
        <OrganizationInvoicesWidget
          customerId={organization?.customerId || ""}
          organization={organization}
        />
      </div>
      <div className={"flex h-fit min-w-0 flex-col gap-6"}>
        <OrganizationNotesWidget organization={organization} />
        <OrganizationEmailsWidget organization={organization} />
        <OrganizationTagsWidget organization={organization} />
      </div>
    </div>
  );
};
